module.exports = __webpack_public_path__ + "img/wz-7-4-4.b564d4a5.jpg";